export const notificationTemplatesTheme = {
  items: {
    borderColor: 'palette.tertiary.20',
    borderRadius: '8px',
    borderWidth: '1px',
    item: 'palette.surface.3',
  },
};
